import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  standalone: true,
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string | undefined): unknown {
    if (!value) return '';

    const splitValues = value.split(':');

    let [hour, minutes] = splitValues;

    const isPMTime = parseInt(hour) >= 12;
    let formattedHour: string | number = hour;

    if (formattedHour.charAt(0) === '0') {
      formattedHour = formattedHour.charAt(1);
    }

    if (parseInt(hour) > 12) {
      formattedHour = parseInt(hour) - 12;
    }
    if (minutes === '00') {
      minutes = '';
    } else {
      minutes = `:${minutes}`;
    }

    return `${formattedHour}${minutes}${isPMTime ? 'pm' : 'am'}`;
  }
}
